import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { PuiValidationService } from '../../../core/index';

@Component({
  selector: 'pui-form-message',
  templateUrl: 'form-message.component.html'
})
export class PuiFormMessageComponent {
  @Input() control: FormControl;
  get message() {
    for (let name in this.control.errors) {
      if (this.control.errors.hasOwnProperty(name) && this.control.touched) {
        return PuiValidationService.getMessage(name, this.control.errors[name]);
      }
    }

    return null;
  }

  constructor() { }
}
